module.exports = __webpack_public_path__ + "img/globe.963cd2a4.svg";